export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5105.ffaa6700.jpg";